import { CmsMeta } from '../cms/cmsMeta';
import { useConfig } from '../../config';
import { useTranslation } from '../../i18n/i18n';
import { Res, useApi } from '../../state/api';
import { MetaContainer } from '../../state/meta';
import { Loop54CampaignProductsRequestBody } from '../../types';
import { ButtonLink } from '../Form/Button';
import { Loader } from '../Loader/Loader';
import { ProductListing } from '../ProductListing/ProductListing';
import { generateUUID } from '../utils';
import './CampaignProducts.css';

export const CampaignProducts = ({ take, showMore = false }: { take?: number; showMore?: boolean }): JSX.Element => {
	const t = useTranslation();
	const config = useConfig();
	const { searchProfileId, randomizeSearchProfileId } = MetaContainer.useContainer();
	const loop54PostHeaders = {
		'Api-Version': 'V3',
		'User-id': randomizeSearchProfileId ? generateUUID() : searchProfileId,
	};
	const resultsLimit = take ?? 12;
	const offset = 0;
	const campaignProductsPayload: Loop54CampaignProductsRequestBody = {
		resultsOptions: {
			skip: offset,
			take: resultsLimit,
			sortBy: [
				{
					type: 'attribute',
					attributeName: 'boost',
					order: 'asc',
				},
			],
		},
		attribute: {
			name: 'campaignStr',
			value: ['true'],
		},
	};

	const { data } = useApi(
		Res.campaignProductsLoop54,
		{ take: resultsLimit },
		config.loop54Api,
		campaignProductsPayload,
		loop54PostHeaders,
		'POST'
	);

	if (!data) return <Loader />;
	if (!data.results || data.results.count === 0) return <></>;

	return (
		<div className={`campaign-products ${showMore ? 'show-more' : ''}`}>
			<h2>{t.campaigns.campaigns}</h2>
			<ProductListing products={data.results.items} />
			{showMore && (
				<center>
					<ButtonLink linkTo={t.routes.campaigns}>{t.generic.viewMore}</ButtonLink>
				</center>
			)}
		</div>
	);
};

export const cmsMeta: CmsMeta = {
	description:
		'Whatever is on campaign right now, from the pricing side, ordered by the `boost` attribute rather than by discount. The row empties itself when no campaign is running.',
	example: ['CampaignProducts', { index: 0, take: 12, showMore: true }],
};
